module.exports = __webpack_public_path__ + "img/minus.fff75228.svg";